import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { Button } from "@avenueops/web-components";
import { ViewColumnsIcon as ViewColumnsIconSolid } from "@heroicons/react/20/solid";
import { ViewColumnsIcon } from "@heroicons/react/24/outline";

interface Props {
  showQuickFilters: boolean;
  setShowQuickFilters: (_: boolean) => void;
  setSelectedProcess: (_: SQLGeneratedProcess | null) => void;
}

export function QuickFiltersToggle({ showQuickFilters, setShowQuickFilters, setSelectedProcess }: Props): JSX.Element {
  return (
    <Button
      onClick={() => {
        setShowQuickFilters(!showQuickFilters);
        setSelectedProcess(null);
      }}
      type="SECONDARY"
      LeadIcon={showQuickFilters ? ViewColumnsIconSolid : ViewColumnsIcon}
      size="MEDIUM"
    />
  );
}
